import React from 'react';

export const DisabilityPaymentPeriodInfo = () => (
  <>
    <p>De eigen risicoperiode gaat af van de uitkeringsduur, houd hier rekening mee bij uw keuze. </p>
  </>
);
